import axios from 'axios'

//const endpoint = 'http://localhost/~crocodylus/da-api/'
//const endpoint = 'http://192.168.1.27/~crocodylus/da-api/'

const endpoint = window.location.href.includes('agency.net.ua') ? 'https://agency.net.ua/api/' :
  window.location.href.includes('localhost') ? 'http://10.8.0.4/~crocodylus/da-api/' : 'http://192.168.1.27/~crocodylus/da-api/'

const token = localStorage.getItem('token')

let headers = {'Content-Type': 'application/x-www-form-urlencoded' }
if ( typeof token != 'undefined' ) headers['X-API-Key'] = token

//const endpoint = window.location.href.includes('10.8.0.4') ? 'http://10.8.0.4/~crocodylus/da-api/' : 'http://localhost/~crocodylus/da-api/'
//const endpoint = 'http://10.8.0.4/~crocodylus/da-api/'

let instance = axios.create({
  baseURL: endpoint,
  headers
//  headers: {'Content-Type': 'application/x-www-form-urlencoded' }
})

//instance.interceptors.response.use((response) => response, (error) => { return Promise.reject(error); }, false)

const download = (url, filename) => {
  instance.get(url, {responseType: 'blob'}).then((response) => {
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();
  }).catch(error => (alert(error)) )
}

export { download }

export default instance

// Content-Type: application/x-www-form-urlencoded нужно чтобы axios не слал запрос OPTIONS
